import { io, Socket } from "socket.io-client";

let chatSocket: Socket | null = null;
let chatSocketToken: string | null = null;
let notificationSocket: Socket | null = null;
let notificationSocketToken: string | null = null;

function getSocketBaseUrl(): string {
  const envBase = (import.meta.env.VITE_API_BASE as string | undefined) || "https://api.bikerhat.com";
  return envBase.replace(/\/api\/(v1|v2)\/?$/, "").replace(/\/+$/, "");
}

export function getChatSocket(token: string): Socket {
  if (chatSocket?.connected && chatSocketToken === token) {
    return chatSocket;
  }
  if (chatSocket?.connected) {
    chatSocket.disconnect();
  }
  const baseUrl = getSocketBaseUrl();
  chatSocket = io(`${baseUrl}/chat`, {
    auth: { token },
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    transports: ["websocket", "polling"],
  });
  chatSocketToken = token;
  return chatSocket;
}

export function disconnectChatSocket() {
  chatSocket?.disconnect();
  chatSocket = null;
  chatSocketToken = null;
}

export function getNotificationSocket(token: string): Socket {
  if (notificationSocket?.connected && notificationSocketToken === token) {
    return notificationSocket;
  }
  if (notificationSocket?.connected) {
    notificationSocket.disconnect();
  }
  const baseUrl = getSocketBaseUrl();
  notificationSocket = io(`${baseUrl}/notifications`, {
    auth: { token },
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    transports: ["websocket", "polling"],
  });
  notificationSocketToken = token;
  return notificationSocket;
}

export function disconnectNotificationSocket() {
  notificationSocket?.disconnect();
  notificationSocket = null;
  notificationSocketToken = null;
}

export function disconnectAllSockets() {
  disconnectChatSocket();
  disconnectNotificationSocket();
}
